import _8REMO_EXT_1 from "./8REMO_EXT_1";
export default {
  _8REMO_EXT_1,
};
